(function(angular){
	'use strict';

	angular
		.module('settingsModule')
		.controller('RemovedDeviceController', [
			'SettingsFactory',
			RemovedDeviceFunction
		]);

	function RemovedDeviceFunction(
		SettingsFactory
	){
		var removedDevice = this;

		removedDevice.$onInit = function() {
			angular.extend(removedDevice, globalConfig);
			SettingsFactory.knownLoginDevices.getDeviceDetail(removedDevice.deviceId)
				.then(function(device) {
					removedDevice.device = device;
				});
		};
	}
})(window.angular);